/**
 * Whether a machine draws the live twin's overlay (`spec-onboarding-3d-plan-plan-scene`, R5.1): the
 * hover, selection, label card and Edit-mode handle `OverlaySwitch` renders, or the "not tracked"
 * box. `'live'` by default, so the live twin, which never provides it, is unchanged. `'none'` is
 * plain models, by Rob's ruling. `'planEditor'` is the plan's machine part, which both 3D plans
 * provide: the live twin's selection outlines on the machine's box, and the box registered for
 * picking (`PlanEditorMachine`, `spec-onboarding-3d-plan-edit-machines` R3.4; the read-only plan since
 * `spec-onboarding-3d-plan-observers-plan-3d`, R2.1). The name is the editor's, where it began.
 */
import { createContext } from 'react';

export type MachineOverlay = 'live' | 'none' | 'planEditor';

export const MachineOverlayContext = createContext<MachineOverlay>('live');
